var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _g3, _circle, _circle2, _circle3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinWithArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 101,
    viewBox: "0 0 115 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 47.1374C65.3331 44.4705 65.3331 40.1466 68 37.4797L91.8538 13.6259L86.3179 13.6259C82.5463 13.6259 79.4889 10.5685 79.4889 6.7969C79.4889 3.02532 82.5463 -0.0321417 86.3179 -0.0321413L108.15 -0.0321356L108.171 -0.0321661L108.218 -0.0320097C109.143 -0.0257841 110.025 0.164657 110.829 0.504493C113.28 1.54117 115 3.96818 115 6.7969L115 6.83821L115 28.6498C115 32.4214 111.942 35.4788 108.171 35.4788C104.399 35.4788 101.342 32.4214 101.342 28.6498L101.342 23.4535L77.6578 47.1374C74.9908 49.8044 70.6669 49.8044 68 47.1374Z",
    fill: "#00B378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 47.1374C65.3331 44.4705 65.3331 40.1466 68 37.4797L91.8538 13.6259L86.3179 13.6259C82.5463 13.6259 79.4889 10.5685 79.4889 6.7969C79.4889 3.02532 82.5463 -0.0321417 86.3179 -0.0321413L108.15 -0.0321356L108.171 -0.0321661L108.218 -0.0320097C109.143 -0.0257841 110.025 0.164657 110.829 0.504493C113.28 1.54117 115 3.96818 115 6.7969L115 6.83821L115 28.6498C115 32.4214 111.942 35.4788 108.171 35.4788C104.399 35.4788 101.342 32.4214 101.342 28.6498L101.342 23.4535L77.6578 47.1374C74.9908 49.8044 70.6669 49.8044 68 47.1374Z",
    fill: "url(#paint0_linear_1152_39601)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 47.1374C65.3331 44.4705 65.3331 40.1466 68 37.4797L91.8538 13.6259L86.3179 13.6259C82.5463 13.6259 79.4889 10.5685 79.4889 6.7969C79.4889 3.02532 82.5463 -0.0321417 86.3179 -0.0321413L108.15 -0.0321356L108.171 -0.0321661L108.218 -0.0320097C109.143 -0.0257841 110.025 0.164657 110.829 0.504493C113.28 1.54117 115 3.96818 115 6.7969L115 6.83821L115 28.6498C115 32.4214 111.942 35.4788 108.171 35.4788C104.399 35.4788 101.342 32.4214 101.342 28.6498L101.342 23.4535L77.6578 47.1374C74.9908 49.8044 70.6669 49.8044 68 47.1374Z",
    fill: "url(#paint1_linear_1152_39601)",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 47.1374C65.3331 44.4705 65.3331 40.1466 68 37.4797L91.8538 13.6259L86.3179 13.6259C82.5463 13.6259 79.4889 10.5685 79.4889 6.7969C79.4889 3.02532 82.5463 -0.0321417 86.3179 -0.0321413L108.15 -0.0321356L108.171 -0.0321661L108.218 -0.0320097C109.143 -0.0257841 110.025 0.164657 110.829 0.504493C113.28 1.54117 115 3.96818 115 6.7969L115 6.83821L115 28.6498C115 32.4214 111.942 35.4788 108.171 35.4788C104.399 35.4788 101.342 32.4214 101.342 28.6498L101.342 23.4535L77.6578 47.1374C74.9908 49.8044 70.6669 49.8044 68 47.1374Z",
    fill: "url(#paint2_radial_1152_39601)",
    fillOpacity: 0.21
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 47.1374C65.3331 44.4705 65.3331 40.1466 68 37.4797L91.8538 13.6259L86.3179 13.6259C82.5463 13.6259 79.4889 10.5685 79.4889 6.7969C79.4889 3.02532 82.5463 -0.0321417 86.3179 -0.0321413L108.15 -0.0321356L108.171 -0.0321661L108.218 -0.0320097C109.143 -0.0257841 110.025 0.164657 110.829 0.504493C113.28 1.54117 115 3.96818 115 6.7969L115 6.83821L115 28.6498C115 32.4214 111.942 35.4788 108.171 35.4788C104.399 35.4788 101.342 32.4214 101.342 28.6498L101.342 23.4535L77.6578 47.1374C74.9908 49.8044 70.6669 49.8044 68 47.1374Z",
    fill: "url(#paint3_radial_1152_39601)",
    fillOpacity: 0.19
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 47.1374C65.3331 44.4705 65.3331 40.1466 68 37.4797L91.8538 13.6259L86.3179 13.6259C82.5463 13.6259 79.4889 10.5685 79.4889 6.7969C79.4889 3.02532 82.5463 -0.0321417 86.3179 -0.0321413L108.15 -0.0321356L108.171 -0.0321661L108.218 -0.0320097C109.143 -0.0257841 110.025 0.164657 110.829 0.504493C113.28 1.54117 115 3.96818 115 6.7969L115 6.83821L115 28.6498C115 32.4214 111.942 35.4788 108.171 35.4788C104.399 35.4788 101.342 32.4214 101.342 28.6498L101.342 23.4535L77.6578 47.1374C74.9908 49.8044 70.6669 49.8044 68 47.1374Z",
    fill: "url(#paint4_radial_1152_39601)",
    fillOpacity: 0.21
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1152_39601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: -1,
    width: 50,
    height: 51
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9999 47.1375C65.333 44.4705 65.333 40.1466 67.9999 37.4797L91.8397 13.6399L86.3177 13.6399C82.5461 13.6399 79.4886 10.5825 79.4886 6.81089C79.4886 3.03931 82.5461 -0.0181532 86.3177 -0.0181528L108.15 -0.0181471L108.171 -0.0181776C108.406 -0.0181776 108.64 -0.00621851 108.869 0.0171313C111.394 0.273754 113.513 1.90605 114.463 4.15269C114.809 4.96972 115 5.86798 115 6.81089L115 6.82802L115 28.6638C115 32.4354 111.942 35.4928 108.171 35.4928C104.399 35.4928 101.342 32.4354 101.342 28.6638L101.342 23.4535L77.6576 47.1375C74.9907 49.8044 70.6668 49.8044 67.9999 47.1375Z",
    fill: "#00B378"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9999 47.1375C65.333 44.4705 65.333 40.1466 67.9999 37.4797L91.8397 13.6399L86.3177 13.6399C82.5461 13.6399 79.4886 10.5825 79.4886 6.81089C79.4886 3.03931 82.5461 -0.0181532 86.3177 -0.0181528L108.15 -0.0181471L108.171 -0.0181776C108.406 -0.0181776 108.64 -0.00621851 108.869 0.0171313C111.394 0.273754 113.513 1.90605 114.463 4.15269C114.809 4.96972 115 5.86798 115 6.81089L115 6.82802L115 28.6638C115 32.4354 111.942 35.4928 108.171 35.4928C104.399 35.4928 101.342 32.4354 101.342 28.6638L101.342 23.4535L77.6576 47.1375C74.9907 49.8044 70.6668 49.8044 67.9999 47.1375Z",
    fill: "url(#paint5_linear_1152_39601)",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9999 47.1375C65.333 44.4705 65.333 40.1466 67.9999 37.4797L91.8397 13.6399L86.3177 13.6399C82.5461 13.6399 79.4886 10.5825 79.4886 6.81089C79.4886 3.03931 82.5461 -0.0181532 86.3177 -0.0181528L108.15 -0.0181471L108.171 -0.0181776C108.406 -0.0181776 108.64 -0.00621851 108.869 0.0171313C111.394 0.273754 113.513 1.90605 114.463 4.15269C114.809 4.96972 115 5.86798 115 6.81089L115 6.82802L115 28.6638C115 32.4354 111.942 35.4928 108.171 35.4928C104.399 35.4928 101.342 32.4354 101.342 28.6638L101.342 23.4535L77.6576 47.1375C74.9907 49.8044 70.6668 49.8044 67.9999 47.1375Z",
    fill: "url(#paint6_linear_1152_39601)",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9999 47.1375C65.333 44.4705 65.333 40.1466 67.9999 37.4797L91.8397 13.6399L86.3177 13.6399C82.5461 13.6399 79.4886 10.5825 79.4886 6.81089C79.4886 3.03931 82.5461 -0.0181532 86.3177 -0.0181528L108.15 -0.0181471L108.171 -0.0181776C108.406 -0.0181776 108.64 -0.00621851 108.869 0.0171313C111.394 0.273754 113.513 1.90605 114.463 4.15269C114.809 4.96972 115 5.86798 115 6.81089L115 6.82802L115 28.6638C115 32.4354 111.942 35.4928 108.171 35.4928C104.399 35.4928 101.342 32.4354 101.342 28.6638L101.342 23.4535L77.6576 47.1375C74.9907 49.8044 70.6668 49.8044 67.9999 47.1375Z",
    fill: "url(#paint7_radial_1152_39601)",
    fillOpacity: 0.41
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9999 47.1375C65.333 44.4705 65.333 40.1466 67.9999 37.4797L91.8397 13.6399L86.3177 13.6399C82.5461 13.6399 79.4886 10.5825 79.4886 6.81089C79.4886 3.03931 82.5461 -0.0181532 86.3177 -0.0181528L108.15 -0.0181471L108.171 -0.0181776C108.406 -0.0181776 108.64 -0.00621851 108.869 0.0171313C111.394 0.273754 113.513 1.90605 114.463 4.15269C114.809 4.96972 115 5.86798 115 6.81089L115 6.82802L115 28.6638C115 32.4354 111.942 35.4928 108.171 35.4928C104.399 35.4928 101.342 32.4354 101.342 28.6638L101.342 23.4535L77.6576 47.1375C74.9907 49.8044 70.6668 49.8044 67.9999 47.1375Z",
    fill: "url(#paint8_radial_1152_39601)",
    fillOpacity: 0.41
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1152_39601)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter0_f_1152_39601)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.9637,
    y: 51.2431,
    width: 2.68593,
    height: 39.7236,
    transform: "rotate(-134.552 72.9637 51.2431)",
    fill: "url(#paint9_linear_1152_39601)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1152_39601)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.496,
    y: 42.0437,
    width: 2.68593,
    height: 39.7236,
    transform: "rotate(-134.552 66.496 42.0437)",
    fill: "url(#paint10_linear_1152_39601)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1152_39601)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.363,
    y: 21.4374,
    width: 2.68593,
    height: 12.8088,
    transform: "rotate(0.785996 101.363 21.4374)",
    fill: "url(#paint11_linear_1152_39601)",
    fillOpacity: 0.05
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter3_f_1152_39601)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 96.5,
    rx: 22.5,
    ry: 2.5,
    fill: "url(#paint12_linear_1152_39601)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_f_1152_39601)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 97.5,
    rx: 18.5,
    ry: 1.5,
    fill: "url(#paint13_linear_1152_39601)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 70,
    r: 28,
    fill: "#FFC001"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 70,
    r: 28,
    fill: "url(#paint14_radial_1152_39601)",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 70,
    r: 28,
    fill: "url(#paint15_radial_1152_39601)",
    fillOpacity: 0.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1152_39601)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.9999,
    cy: 70,
    r: 22.8421,
    fill: "url(#paint16_linear_1152_39601)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1152_39601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2913 78.8399H39.8433V78.7199C41.7753 77.9599 43.0773 76.0399 43.0773 73.9999C43.0773 73.2399 42.9933 72.4399 42.8253 71.6799H49.6293C50.3853 71.6799 50.8053 71.2799 50.8053 70.5199V68.7199C50.8053 67.9999 50.3853 67.5599 49.6293 67.5599H41.7753C41.5653 66.5199 41.3973 65.4799 41.3973 64.3999C41.3973 61.5999 42.9093 59.9999 45.6393 59.9999C47.6553 59.9999 49.0833 60.8399 50.3433 62.3999C50.7213 62.8799 51.3093 62.8799 52.0233 62.5999L54.7953 61.4399C55.4673 61.1599 55.5933 60.6399 55.1733 59.9599C53.1993 56.8399 50.0073 54.9999 45.6393 54.9999C39.6753 54.9999 35.5593 58.3999 35.5593 63.4399C35.5593 64.9999 35.8953 66.3599 36.2733 67.5599H34.8453C34.0893 67.5599 33.6693 67.9599 33.6693 68.7199V70.5199C33.6693 71.2799 34.0473 71.6799 34.8453 71.6799H37.7013C37.8693 72.2799 37.9533 72.9199 37.9533 73.5599C37.9533 75.7999 36.6513 77.5199 34.3413 78.5199C33.9213 78.7199 33.6693 79.2399 33.6693 79.9199V82.6799C33.6693 83.3999 34.0893 83.7999 34.8453 83.7999H54.2913C55.0893 83.7999 55.4673 83.3999 55.4673 82.6799V79.9599C55.4673 79.1999 55.0893 78.8399 54.2913 78.8399Z",
    fill: "#957000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1152_39601",
    x: 65.6162,
    y: 15.9976,
    width: 41.1186,
    height: 40.7087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73162,
    result: "effect1_foregroundBlur_1152_39601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1152_39601",
    x: 59.1485,
    y: 6.79827,
    width: 41.1186,
    height: 40.7087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73162,
    result: "effect1_foregroundBlur_1152_39601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1152_39601",
    x: 98.4558,
    y: 18.7058,
    width: 8.32456,
    height: 18.3076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36581,
    result: "effect1_foregroundBlur_1152_39601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1152_39601",
    x: 0,
    y: 92,
    width: 49,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1152_39601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1152_39601",
    x: 9,
    y: 94,
    width: 41,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1152_39601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1152_39601",
    x: 22.1578,
    y: 47.1579,
    width: 46.421,
    height: 47.1579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.736842,
    dy: 1.47368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.94737
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1152_39601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1152_39601",
    x: 23.0001,
    y: 50,
    width: 42.7368,
    height: 40.7368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.736842,
    dy: 0.736842
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.736842
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1152_39601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1152_39601",
    x1: 102.621,
    y1: -4.11559,
    x2: 102.621,
    y2: 8.17669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1152_39601",
    x1: 116.366,
    y1: 8.17669,
    x2: 106.805,
    y2: 8.17669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1152_39601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.8545 10.9083) rotate(-38.6597) scale(8.74547 8.74546)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1152_39601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9201 38.4224) rotate(11.3099) scale(13.2096 13.2095)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1152_39601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.708 34.1271) rotate(-56.3098) scale(9.84901 9.84903)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1152_39601",
    x1: 97.9182,
    y1: -4.3554,
    x2: 97.9182,
    y2: 8.65608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1152_39601",
    x1: 116.884,
    y1: 8.65608,
    x2: 103.692,
    y2: 8.65608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1152_39601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.8842 11.5475) rotate(-31.5371) scale(11.056 10.1039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1152_39601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.0381 36.1247) rotate(-49.0075) scale(11.4923 12.3283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1152_39601",
    x1: 74.3067,
    y1: 51.2431,
    x2: 74.3067,
    y2: 90.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1152_39601",
    x1: 67.8389,
    y1: 42.0437,
    x2: 67.8389,
    y2: 81.7673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1152_39601",
    x1: 102.706,
    y1: 21.4374,
    x2: 102.706,
    y2: 34.2462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1152_39601",
    x1: 37.8784,
    y1: 95.25,
    x2: 5.64621,
    y2: 94.0665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1152_39601",
    x1: 40.5,
    y1: 96.75,
    x2: 14.0293,
    y2: 95.4181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1152_39601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3333 93.4839) rotate(-57.368) scale(38.6108 45.1532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84640E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84640E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1152_39601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.6923 43.8064) rotate(138.631) scale(28.6998 38.119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1152_39601",
    x1: 64.9999,
    y1: 53.9999,
    x2: 35.9999,
    y2: 91.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1A902"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinWithArrow);
export default __webpack_public_path__ + "static/media/coinWithArrow.125d9d6201e4172fd1805d14983e0034.svg";
export { ForwardRef as ReactComponent };